import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import ProductButtons from './ProductButtons';
import ProductInfo from './ProductInfo';

const ErrorMessage = ({ msgContent="" }) => {

  return (
      <div className="card mb-4">
        <div className="card-body">
          <div className="row align-items-center">
            {/* Column 1: Icon */}
            <div className="col-md-2 col-sm-6 text-center">
              <div className="icon-container">
                  <img style={{height: 100, paddingLeft:26}} src={process.env.PUBLIC_URL + '/keinprodukt.png'} />
              </div>
            </div>
            <div className="col-md-1 vertical-line"></div>
            <div className="col-md-9 col-sm-6 text-center">
              <div className="icon-container" style={{paddingTop: '10px'}}>
                  <h3>Kein passendes Produkt gefunden.</h3>
                  <p>{msgContent || "Aufgrund der eingegebenen Daten ist keine Leistbarkeit für den Kredit gegeben."}</p>
                  <p><font style={{color: '#E10707'}}>Tipp! </font>Reduzieren Sie entweder die Projektkosten und damit den Kaufpreis oder erhöhen Sie die Eigenmittel <br/>(zB. durch weitere Reserven, oder ggf. hinzuziehen weiterer Kreditnehmer*innen).</p>

              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default ErrorMessage;
